// Supabase Configuration
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://kahwszylehddzbojzdnh.supabase.co'
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImthaHdzenlsZWhkZHpib2p6ZG5oIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk1MzQyNzYsImV4cCI6MjA4NTExMDI3Nn0.5ns9fwQ1EltByhuZCmUoRnHn6nPFnsFi3-AWEPEA8vA'

// App URL - set this to your production URL for magic link redirects
export const APP_URL = import.meta.env.VITE_APP_URL || 'https://secondshiftventures.com'

// App Configuration
export const APP_CONFIG = {
  appName: 'Second Shift Ventures',
  version: '2.0.0',

  // Routes
  routes: {
    public: '/',
    login: '/login',
    signup: '/signup',
    dashboard: '/dashboard',
    business: '/dashboard/business',
    subscriptions: '/dashboard/subscriptions',
    todos: '/dashboard/todos',
    reports: '/dashboard/reports',
    users: '/dashboard/users',
  },

  // Protected routes that require authentication
  protectedRoutes: ['/dashboard'],

  // Admin-only routes
  adminRoutes: ['/dashboard/users'],
}

// Check if Supabase is configured
export function isSupabaseConfigured() {
  return SUPABASE_URL !== 'YOUR_SUPABASE_URL' &&
         SUPABASE_ANON_KEY !== 'YOUR_SUPABASE_ANON_KEY'
}
